import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/feature-intro', label: '功能介绍' },
  { to: '/category/tutorial', label: '使用教程' },
  { to: '/category/download', label: '下载指南' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-seedling-line text-2xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
            </div>
            <span
              className="text-xl font-heading"
              style={{ color: scrolled ? 'oklch(var(--foreground-950))' : 'oklch(var(--foreground-50))' }}
            >
              雏鸟
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  isActive(link.to)
                    ? 'font-bold'
                    : ''
                }`}
                style={{
                  color: scrolled
                    ? isActive(link.to)
                      ? 'oklch(var(--primary-500))'
                      : 'oklch(var(--foreground-700))'
                    : isActive(link.to)
                      ? 'oklch(var(--primary-400))'
                      : 'oklch(var(--foreground-50))',
                }}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <a
              href="#download"
              className="px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
              style={{
                backgroundColor: 'oklch(var(--primary-500))',
                color: '#fff',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'oklch(var(--primary-600))';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'oklch(var(--primary-500))';
              }}
            >
              立即下载
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
              style={{ color: scrolled ? 'oklch(var(--foreground-950))' : '#fff' }}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  isActive(link.to) ? 'font-bold' : ''
                }`}
                style={{
                  color: isActive(link.to)
                    ? 'oklch(var(--primary-500))'
                    : 'oklch(var(--foreground-700))',
                }}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#download"
              className="px-5 py-2.5 rounded-full text-sm font-medium text-center whitespace-nowrap cursor-pointer transition-all duration-200"
              style={{
                backgroundColor: 'oklch(var(--primary-500))',
                color: '#fff',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'oklch(var(--primary-600))';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'oklch(var(--primary-500))';
              }}
            >
              立即下载
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}